import toast from "react-hot-toast";

import { nextCargoApi } from "@/store";

import { TruckSimple } from "../_shared";

export const truckBrandsApi = nextCargoApi.injectEndpoints({
  endpoints: (build) => ({
    getTruckBrands: build.query<TruckSimple[], void>({
      query: () => "/truck-brand",
      onQueryStarted: async (args, { queryFulfilled }) => {
        toast.promise(queryFulfilled, {
          loading: "Carregando marcas de caminhão...",
          success: "Marcas de caminhão carregadas com sucesso!",
          error: "Erro ao carregar marcas de caminhão."
        });
      }
    }),
    getTruckBrand: build.query<TruckSimple, Pick<TruckSimple, "id">>({
      query: ({ id }) => `/truck-brand/${id}`,
      onQueryStarted: async (args, { queryFulfilled }) => {
        toast.promise(queryFulfilled, {
          loading: "Carregando marca de caminhão...",
          success: "Marca de caminhão carregada com sucesso!",
          error: "Erro ao carregar marca de caminhão."
        });
      }
    }),
    saveTruckBrand: build.mutation<TruckSimple, Modifiers.Modify<TruckSimple, { id?: number }>>({
      query: ({ id, name }) => ({
        url: "/truck-brand/save",
        method: "POST",
        body: {
          id,
          name,
          truckBrand: {
            id
          }
        }
      }),
      onQueryStarted: async (args, { queryFulfilled }) => {
        const isEdit = Boolean(args.id);
        toast.promise(queryFulfilled, {
          loading: isEdit ? "Atualizando marca de caminhão..." : "Criando marca de caminhão...",
          success: isEdit ? "Marca de caminhão atualizada com sucesso!" : "Marca de caminhão criada com sucesso!",
          error: isEdit ? "Erro ao atualizar marca de caminhão." : "Erro ao criar marca de caminhão."
        });
      }
    }),
    deleteTruckBrand: build.mutation<void, Pick<TruckSimple, "id">>({
      query: ({ id }) => ({
        url: `/truck-brand/delete/${id}`,
        method: "DELETE"
      }),
      onQueryStarted: async (args, { queryFulfilled }) => {
        toast.promise(queryFulfilled, {
          loading: "Excluindo marca de caminhão...",
          success: "Marca de caminhão excluída com sucesso!",
          error: "Erro ao excluir marca de caminhão."
        });
      }
    })
  })
});

truckBrandsApi.enhanceEndpoints({
  addTagTypes: ["TruckBrand"],
  endpoints: {
    getTruckBrands: {
      providesTags: (result) =>
        result ? [...result.map(({ id }) => ({ type: "TruckBrand" as const, id })), { type: "TruckBrand", id: "LIST" }] : [{ type: "TruckBrand", id: "LIST" }]
    },
    getTruckBrand: {
      providesTags: (result, error, { id }) => [{ type: "TruckBrand", id }]
    },
    saveTruckBrand: {
      invalidatesTags: (result, err, { id }) => [{ type: "TruckBrand", id }]
    },
    deleteTruckBrand: {
      invalidatesTags: (result, err, { id }) => [{ type: "TruckBrand", id }]
    }
  }
});
